import { useState } from 'react';
import { useSelector } from 'react-redux';

import { getExportActivities } from '../services';

export function useExportActivities() {
  const [exportLoading, setExportLoading] = useState(false);
  const {
    activitiesFilters: { data: filters },
  } = useSelector((state) => state.activitiesReducer);

  const { account, authenticityToken } = useSelector((state) => state.internalReducer.internal);

  const mutateObject = (obj, removeAttributes) =>
    Object.entries(obj).reduce(
      (acc, [key, value]) => (removeAttributes.includes(key) ? acc : { ...acc, [key]: value }),
      {},
    );

  const reducedFilters = mutateObject(filters, ['page', 'per_page']);

  const exportActivities = async ({ onError = () => {}, onSuccess = () => {} }) => {
    try {
      setExportLoading(true);
      await getExportActivities({ accountId: account?.id, authToken: authenticityToken, filters: reducedFilters });
      setExportLoading(false);
      onSuccess();
    } catch (e) {
      setExportLoading(false);
      onError(e);
    }
  };

  return { exportActivities, exportLoading };
}

export default useExportActivities;
